// extracted by mini-css-extract-plugin
export var container = "_8z-0";
export var fallback = "_8z-5";
export var fallbackIcon = "_8z-6";
export var hidden = "_8z-2";
export var image = "_8z-3";
export var loaded = "_8z-4";
export var placeholder = "_8z-1";